import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    rootContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    container: {
      padding: '24px 67px',
      maxHeight: '50vh',
      overflowY: 'scroll',
    },
    divFlex: {
      display: 'flex',
      position: 'relative',
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginBottom: '4px',
      borderRadius: 10,
      '& .content-trash, & .drag-handle': {
        visibility: 'hidden',
      },
      '&:hover': {
        zIndex: 9,
        backgroundColor: '#f0f0f0',
        '& .content-trash, & .drag-handle': {
          visibility: 'visible',
          height: 'fit-content',
        },
      },
      '&.text-area': {
        alignItems: 'flex-start',
        padding: '3px 9px',
      },
      '& img': {
        marginTop: 4,
        userSelect: 'none',
        userDrag: 'none',
      },
      '& *':{
        userDrag: 'none',
      }
    },
    divSubsection: {
      margin: '0px 15px',
      width: '100%',
      display: 'flex',
      alignItems: 'flex-start',
      '& .limit-character': {
        margin: '12px 5px 0 auto',
        color: theme.custom.colors.midGray,
      },
      '& textarea': {
        marginBottom: 2,
      },
      '& span': {
        marginRight: 5,
        marginTop: 4
      }
    },
    inputSubsection: {
      margin: 'auto',
      marginBottom: 5,
      color: theme.custom.colors.midBlack,
      width: '100%',
      border: 'none',
      outline: 'none',
      display: 'block',
      resize: 'none',
      overflow: 'hidden',
      font: 'normal normal 400 14px/24px Public-Sans',
      '&:hover': {
        backgroundColor: "#f0f0f0"
      }
    },
    iconTrash: {
      cursor: 'pointer',
      height: 16,
      width: 16
    },
    btnAddContent: {
      cursor: 'pointer',
      padding: '0 40px 10px',
      textTransform: 'unset',
      '& span': {
        font: 'normal normal 700 14px/24px Lato',
        color: theme.custom.colors.midBlack,
      },
      '&:hover': {
        background: '#fff'
      }
    },
    footerModal: {
      height: '15.3%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '&>div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
        font: 'normal normal 500 16px/24px Public-Sans',
        color: theme.custom.colors.primary,
      }
    },
    btnAddRecipeBody: {
      '& button': {
        height: 32,
        background: theme.custom.colors.primary,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '&>span:first-child': {
          color: theme.custom.colors.white,
          font: theme.custom.font.montserrat16Bold,
        },
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    backButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "#D2D2D2",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
    },

    cancelButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "transparent",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
      marginRight: 10,
    },
    nextButton: {
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      border: "none",
      backgroundColor: "#0C85F4",
      borderRadius: "100px",
      color: "white",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: "24px",
      cursor: "pointer",
    },
    nextButtonIconContainer: {
      marginLeft: "7px",
    },
    iconLoading: {
      marginLeft: '15px',
      '& svg': {
        color: '#fff',
      },
    },
  };
});

export default useStyles;
